import { render, staticRenderFns } from "./HalfDayPolicy.vue?vue&type=template&id=21fd7928&scoped=true&"
import script from "./HalfDayPolicy.vue?vue&type=script&lang=js&"
export * from "./HalfDayPolicy.vue?vue&type=script&lang=js&"
import style0 from "./HalfDayPolicy.vue?vue&type=style&index=0&id=21fd7928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd7928",
  null
  
)

export default component.exports